module.exports = __webpack_public_path__ + "static/media/Dashboard.6b7ff33e.webp";